module.exports = __webpack_public_path__ + "static/media/down.7c938411.svg";